const r = (l, a) => {
  var n, o, u;
  return (l == null ? void 0 : l.length) > 0 ? a ? [{
    alt: (n = l[0]) == null ? void 0 : n.originalAlt,
    url: (o = l[0]) == null ? void 0 : o.original,
    urlWebP: (u = l[0]) == null ? void 0 : u.originalWebP
  }] : l.map(i => ({
    alt: i == null ? void 0 : i.originalAlt,
    url: i == null ? void 0 : i.original,
    urlWebP: i == null ? void 0 : i.originalWebP
  })) : [];
};
export { r as returnImage };